/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessDto } from '../../models/kyc-process-dto';
import { KycProcessWithoutClientCreateDto } from '../../models/kyc-process-without-client-create-dto';

export interface CreateWithoutClient$Params {
      body: KycProcessWithoutClientCreateDto
}

export function createWithoutClient(http: HttpClient, rootUrl: string, params: CreateWithoutClient$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessDto>> {
  const rb = new RequestBuilder(rootUrl, createWithoutClient.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessDto>;
    })
  );
}

createWithoutClient.PATH = '/kyc/processes/without-client';
